import { FileDownloadOutlined } from '@mui/icons-material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import { LoadingButton } from '@mui/lab';
import {
  Button,
  CardHeader,
  Chip,
  Grid,
  Menu,
  Modal,
  Paper,
  Skeleton,
  TableContainer,
  TableSortLabel,
  Typography
} from '@mui/material';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import SvgIcon from '@mui/material/SvgIcon';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Edit02Icon from '@untitled-ui/icons-react/build/esm/Edit02';
import PlusIcon from '@untitled-ui/icons-react/build/esm/Plus';
import { format } from 'date-fns';
import moment from 'moment';
import { useCallback, useEffect, useMemo, useState, type FC } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { BootstrapDialog } from 'src/components/common-modals/BootstrapDialog';
import { Scrollbar } from 'src/components/scrollbar';
import useCurrentUser from 'src/hooks/use-current-user';
import RightIcon from 'src/icons/untitled-ui/duocolor/rightIcon';
import { useStopwatch } from 'src/layouts/check-in-checkout/StopwatchContext';
import useEffectAfterMount from 'src/layouts/components/useEffectAfterMount';
import emptyImg from 'src/pages/therapist-dashboard/therapist-document/image-removebg-preview.png';
import { paths, permissions } from 'src/paths';
import {
  checkPendingDocsAlertAction,
  getTherapistDocumentCreateEditDataAction,
  resetPendingDocsAlertAction,
  resetTherapistDocumentCreateEditDataAction,
  resetUuidAction,
} from 'src/redux/actions/documentationAction';
import { getListOfTherapistAvailability } from 'src/redux/actions/myAvailabilityAction';
import {
  getAllPatientsByAction,
  getPatientIdAction,
  resetPatientRecordAction,
  switchTherapistDisciplineAction,
} from 'src/redux/actions/patientAction';
import {
  getAllTodaysDocumentAction,
  getAllTodaysDocumentCSVAction,
  getAllTodaysDocumentCSVRestAction,
  previewDashboardDoc,
  resetDashboardSubmittedDoc,
  viewSignatureDashboardDoc,
} from 'src/redux/actions/therapist-dashboard-action';
import { getAccessToken } from 'src/routes/AuthContext';
import { getDisplayString } from 'src/utils/getDaysBtDate';
import { viewFormByFormID } from 'src/utils/jotform-functions';
import LoaderIcon from '../../../../src/components/LoaderImg/loader.gif';
import useDialogVisibility from '../../../utils/dialog-hide';
import { ClipBoard, DocumentIcons } from '../dashboard-icon';
import ClockInOutModal from '../time-in-out/clock-in-out-modal';
import {
  convertToCSV,
  DisciplineType,
  docStatusTypes,
  documentTypes
} from './document-manegment-const';
import { MenuDateFilter } from './menu-date-filter';
import MultiSelectWithSearch from './table-header-multiselect-search';
import { TableHeaderMultiselect } from './table-hearder-multiselect';
import { useFeatureToggleWhenReady } from 'src/hooks/use-feature-toggle';
import { recheckDischarge } from 'src/config';
import DischargeRecheckModal from 'src/components/common-modals/discharge-recheck-modal';

const DocumentManagement: FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isRunning, startStopwatch } = useStopwatch();

  const { canShowDialog: canShowClockInDialog } = useDialogVisibility('clock_in_do_not_show');

  const getDocumentRes = useSelector((state: any) => state.dashboardDocumentListReducer);
  const checkoutResponse = useSelector((state: any) => state.checkoutReducer);
  const [providerId, firstName, lastName] = useCurrentUser(['providerId', 'firstName', 'lastName']);
  const { patients, patientDetails, episodeOfCare, details, createDocument } = paths;

  const permissionData = useSelector(
    (state: any) => state?.getTherapistProfileReducer?.response?.data?.currentPermissions
  );

  const csvDocumentData = useSelector((state: any) => state.dashboardDocumentListCsv);

  const totalPatientRes = useSelector((state: any) => state.getAllPatientsReducer);

  const thePayComeDetailsReducer = useSelector(
    (state: any) => state.thePayComeDetailsReducer?.response?.data
  );

  const { UPDATE_RECERTIFICATION, UPDATE_EVAL } = permissions;

  const [showForm, setShowForm] = useState<any>({
    openForm: false,
    formId: '',
  });
  const [sortConfig, setSortConfig] = useState<{ key: string; direction: 'asc' | 'desc' }>({
    key: 'dueDate',
    direction: 'desc',
  });
  const [isRecheckDischarge] = useFeatureToggleWhenReady(recheckDischarge, 'ENTERPRISE');
  const checkPendingDocsAlert = useSelector((state: any) => state.checkPendingDocsAlert);

  const [showDischargeModal, setShowDischargeModal] = useState<boolean>(false);


  //clock in modal

  const [isClockIn, setIsClockIn] = useState(false);
  const [notToShowAgain, setNotToShowAgain] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState<any>('');

  const [iframeRef, setIframeRef] = useState<any | null>(null);

  const updateIFrameRef = useCallback((node: any) => {
    setIframeRef(node);
  }, []);

  useEffect(() => {
    const iframeElement = iframeRef;

    if (iframeElement) {
      const interval = setInterval(async () => {
        const response = await getAccessToken();
      }, 15000);

      return () => {
        clearInterval(interval);
      };
    }
  }, [iframeRef]);

  useEffect(() => {
    dispatch(getListOfTherapistAvailability());
  }, []);

  useEffect(() => {
    if (!checkPendingDocsAlert?.isSuccess && checkPendingDocsAlert?.response === null) return;
    if (!checkPendingDocsAlert?.isSuccess && checkPendingDocsAlert?.response !== null) return;

    if (checkPendingDocsAlert?.response?.length) {
      setShowDischargeModal(true);
      return;
    }
    // navigate to discharge
    dispatch(resetPendingDocsAlertAction())
    navigate('/document/document-edit', {
      state: {
        document: selectedDocument,
      },
    });
  }, [checkPendingDocsAlert]);


  const navigateToSignature = useCallback((document?: any) => {
    navigate(
      `/dashboard/doc-sign`,
      {
        state: {
          document,
        },
      }
    );
  }, [selectedDocument])

  const handleSignatureNavigation = (formId: any) => {
    setActionToBeContinue('SIGN_DOCUMENT');
    setSelectedDocument(formId);
    if (
      canShowClockInDialog() &&
      !isRunning &&
      !notToShowAgain &&
      !thePayComeDetailsReducer?.enablePaycom &&
      !thePayComeDetailsReducer?.enableHostedTime &&
      !thePayComeDetailsReducer?.enablePaylocity
    ) {
      setIsClockIn(true);
      return;
    }
    dispatch(viewSignatureDashboardDoc(formId));
    navigateToSignature(formId);
  };

  const previewDocument = (formId: any) => {
    dispatch(previewDashboardDoc(formId));
    navigate('/dashboard/doc');
  };

  useEffect(() => {
    if (!csvDocumentData.isGetDocuments && csvDocumentData?.response === null) return;
    if (!csvDocumentData.isGetDocuments && csvDocumentData?.response !== null) {
      dispatch(getAllTodaysDocumentCSVRestAction());
      return;
    }
    if (csvDocumentData.isGetDocuments && csvDocumentData?.response !== null) {
      const csvContent = convertToCSV(csvDocumentData?.response?.data?.content);

      const blob = new Blob([csvContent], { type: 'text/csv' });
      const url = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = 'Documents_Due_Todays_Date.csv';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(url);

      dispatch(getAllTodaysDocumentCSVRestAction());
    }
  }, [csvDocumentData]);

  const handleModalClose = () => {
    setShowForm({
      openForm: false,
      formId: '',
    });
  };

  const [actionToBeContinue, setActionToBeContinue] = useState('');

  const handleDocumentEdit = useCallback(
    (document: any) => {
      setSelectedDocument(document);
      setActionToBeContinue('EDIT_MY_DOCUMENT');

      if (
        canShowClockInDialog() &&
        !isRunning &&
        !notToShowAgain &&
        !thePayComeDetailsReducer?.enablePaycom &&
        !thePayComeDetailsReducer?.enableHostedTime &&
        !thePayComeDetailsReducer?.enablePaylocity &&
        canShowClockInDialog()
      ) {
        setIsClockIn(true);
        return;
      }
      dispatch(resetTherapistDocumentCreateEditDataAction());
      dispatch(getTherapistDocumentCreateEditDataAction(document));

      // discharge doc prevent
      if (isRecheckDischarge && document?.formType?.includes('DISCHARGE') && !document?.submissionId) {
        dispatch(
          checkPendingDocsAlertAction({
            eocId: document?.episodeOfCareId,
            params: {
              discipline: document?.type,
              localDate: moment(new Date()).format('YYYY-MM-DD'),
            },
          })
        );
        return
      }

      navigate('/document/document-edit', {
        state: {
          document,
        },
      });
    },
    [isRunning, notToShowAgain, thePayComeDetailsReducer, isRecheckDischarge]
  );

  const checkEditPermission = (document: any) => {
    if (
      document.formType?.includes('RECERTIFICATION') &&
      !permissionData.includes(UPDATE_RECERTIFICATION)
    ) {
      return false;
    }
    if (document.formType?.includes('EVALUATION') && !permissionData.includes(UPDATE_EVAL)) {
      return false;
    }
    return true;
  };

  useEffect(() => {
    if (checkoutResponse.isGetCheckIn && checkoutResponse?.response?.content !== null) {
      if (checkoutResponse?.clockAction === 'CLOCK_IN_SUCCESS') {
        if (actionToBeContinue === 'SIGN_DOCUMENT') {
          dispatch(viewSignatureDashboardDoc(selectedDocument));
          navigateToSignature(selectedDocument);
          return;
        }
        if (actionToBeContinue === 'EDIT_MY_DOCUMENT') {
          dispatch(resetTherapistDocumentCreateEditDataAction());
          dispatch(getTherapistDocumentCreateEditDataAction(selectedDocument));

          // discharge doc prevent
          if (isRecheckDischarge && selectedDocument?.formType?.includes('DISCHARGE') && !selectedDocument?.submissionId) {
            dispatch(
              checkPendingDocsAlertAction({
                eocId: selectedDocument?.episodeOfCareId,
                params: {
                  discipline: selectedDocument?.type,
                  localDate: moment(new Date()).format('YYYY-MM-DD'),
                },
              })
            );
            return
          }

          navigate('/document/document-edit', {
            state: {
              document: selectedDocument,
            },
          });
        }
      }
    }
  }, [checkoutResponse]);

  const handleIsClock = () => {
    if (actionToBeContinue === 'SIGN_DOCUMENT') {
      dispatch(viewSignatureDashboardDoc(selectedDocument));
      navigateToSignature(selectedDocument);
      return;
    }
    if (actionToBeContinue === 'EDIT_MY_DOCUMENT') {
      dispatch(resetTherapistDocumentCreateEditDataAction());
      dispatch(getTherapistDocumentCreateEditDataAction(selectedDocument));

      if (isRecheckDischarge && selectedDocument?.formType?.includes('DISCHARGE') && !selectedDocument?.submissionId) {
        dispatch(
          checkPendingDocsAlertAction({
            eocId: selectedDocument?.episodeOfCareId,
            params: {
              discipline: selectedDocument?.type,
              localDate: moment(new Date()).format('YYYY-MM-DD'),
            },
          })
        );
        return
      }
      navigate('/document/document-edit', {
        state: {
          document: selectedDocument,
        },
      });
    }
    setNotToShowAgain(true);
    setIsClockIn(false);
  };

  useEffect(() => {
    if (providerId) {
      dispatch(resetDashboardSubmittedDoc());
      setSelectedTherapist([
        {
          label: `${firstName} ${lastName}`,
          value: providerId,
        },
      ]);
    }
  }, [providerId]);

  const goToEoc = (document: any) => {
    dispatch(getPatientIdAction(document?.patientId));
    dispatch(switchTherapistDisciplineAction(''));
    navigate(`${patients}/${patientDetails}${episodeOfCare}${details}`, {
      state: {
        episodeOfCareId: document?.episodeOfCareId,
        getPatientId: document?.patientId,
      },
    });
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const [getCurrentItem, setGetCurrentItem] = useState<any>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: any, item: any) => {
    setAnchorEl(event.currentTarget);
    setGetCurrentItem(item);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setGetCurrentItem(null);
  };

  const HandleStartClock = () => {
    const millageInfo = {
      locationType: 'BUILDING',
      payByMilage: null,
    };
    startStopwatch('MILLAGE', millageInfo);
  };
  const listOfTherapistAvailability = useSelector(
    (state: any) => state.getListOfTherapistAvaiReducer
  );
  const [selectedTherapist, setSelectedTherapist] = useState<any>([]);

  const [selectedDocumentType, setSelectedDocumentType] = useState<any>([]);
  const [selectedDisciples, setSelectedDisciples] = useState([]);
  const [selectedPatient, setSelectedPatient] = useState<any>([]);
  const [selectedStatus, setSelectedStatus] = useState<any>([]);
  const [selectedDueDate, setSelectedDueDate] = useState<any>({
    startDate: '',
    endDate: '',
  });

  const getListOfValues = (items: any) => {
    return items?.map((therapist: any) => therapist?.value);
  };

  const getAllDocumentApiCall = (page: number) => {
    dispatch(
      getAllTodaysDocumentAction({
        param: {
          page: page,
          therapistIds: selectedTherapist?.length
            ? getListOfValues(selectedTherapist)
            : getListOfValues(getTherapistList),
          pageSize: 20,
          documentTypes: selectedDocumentType?.length
            ? getListOfValues(selectedDocumentType)
            : null,
          types: selectedDisciples?.length ? getListOfValues(selectedDisciples) : null,
          dueStatus: selectedStatus?.length ? getListOfValues(selectedStatus) : null,
          startDate: selectedDueDate?.startDate
            ? moment(selectedDueDate?.startDate).format('YYYY-MM-DD')
            : null,
          endDate: selectedDueDate?.endDate
            ? moment(selectedDueDate?.endDate).format('YYYY-MM-DD')
            : null,
          patientIds: selectedPatient?.length ? getListOfValues(selectedPatient) : null,
          sortBy: sortConfig?.key,
          sortDirection: sortConfig?.direction,
        },
      })
    );
  };

  useEffectAfterMount(() => {
    // if (selectedTherapist?.length) {
    dispatch(resetDashboardSubmittedDoc());
    getAllDocumentApiCall(0);
    // }
  }, [
    selectedDocumentType,
    selectedStatus,
    selectedDueDate,
    selectedPatient,
    selectedTherapist,
    selectedDisciples,
    sortConfig,
  ]);

  const getTherapistList = useMemo(() => {
    const mappedTherapists = listOfTherapistAvailability?.response?.data?.map((res: any) => {
      return {
        label:
          res?.uuid === providerId
            ? `${res?.lastName}, ${res?.firstName} (Me)`
            : `${res?.lastName}, ${res?.firstName}`,
        value: res?.uuid,
      };
    });

    return mappedTherapists?.sort((a: any, b: any) => {
      return a?.label.localeCompare(b?.label);
      // if (a?.value === providerId) return -1;
      // if (b?.value === providerId) return 1;
      // return 0;
    });
  }, [listOfTherapistAvailability, providerId]);

  const [pageNo, setPageNo] = useState(0);

  useEffect(() => {
    dispatch(resetPatientRecordAction());
    dispatch(
      getAllPatientsByAction({
        data: {
          searchString: '',
        },
        params: {
          page: 0,
          pageSize: 20,
          active: true,
        },
      })
    );
    dispatch(resetUuidAction());
  }, []);
  const getAllPatientList = useMemo(() => {
    return totalPatientRes?.totalPatients.map((res: any) => {
      return {
        label: `${res?.lastName}, ${res?.firstName}`,
        value: res?.uuid,
      };
    });
  }, [totalPatientRes]);

  const handleSort = (key: string) => {
    const isAsc = sortConfig.key === key && sortConfig.direction === 'asc';
    const direction = isAsc ? 'desc' : 'asc';
    setSortConfig({ key, direction });
  };

  const handleDownloadCSV = () => {
    dispatch(getAllTodaysDocumentCSVRestAction());
    dispatch(
      getAllTodaysDocumentCSVAction({
        param: {
          page: 0,
          therapistIds: selectedTherapist?.length
            ? getListOfValues(selectedTherapist)
            : getListOfValues(getTherapistList),
          pageSize: getDocumentRes?.response?.data?.totalElements
            ? getDocumentRes?.response?.data?.totalElements
            : 2000,
          documentTypes: selectedDocumentType?.length
            ? getListOfValues(selectedDocumentType)
            : null,
          types: selectedDisciples?.length ? getListOfValues(selectedDisciples) : null,
          dueStatus: selectedStatus?.length ? getListOfValues(selectedStatus) : null,
          startDate: selectedDueDate?.startDate
            ? moment(selectedDueDate?.startDate).format('YYYY-MM-DD')
            : null,
          endDate: selectedDueDate?.endDate
            ? moment(selectedDueDate?.endDate).format('YYYY-MM-DD')
            : null,
          patientIds: selectedPatient?.length ? getListOfValues(selectedPatient) : null,
          sortBy: sortConfig?.key,
          sortDirection: sortConfig?.direction,
        },
      })
    );
  };
  const handleSortMultiselect = useCallback((label: any, direction: any) => {
    if (label === 'Therapist') return setSortConfig({ key: 'therapistName', direction });
    if (label === 'Document Type') return setSortConfig({ key: 'documentType', direction });
    if (label === 'Discipline') return setSortConfig({ key: 'discipline', direction });
    if (label === 'Status') return setSortConfig({ key: 'dueStatus', direction });
    if (label === 'PatientName') return setSortConfig({ key: 'patientName', direction });
  }, []);

  return (
    <>
      <Card>
        <CardHeader
          title={
            <>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Typography variant="h6">Documents Due</Typography>
                  {getDocumentRes?.loading ? (
                    <Box sx={{ width: 100, ml: 3 }}>
                      <Typography
                        width={'100%'}
                        variant="h4"
                      >
                        <Skeleton animation="pulse" />
                      </Typography>
                    </Box>
                  ) : (
                    <Chip
                      label={`${
                        getDocumentRes?.response?.data?.totalElements
                          ? getDocumentRes?.response?.data?.totalElements
                          : '0'
                      } Document`}
                      variant="outlined"
                      sx={{ marginLeft: '10px' }}
                    />
                  )}
                </Box>
                <Box>
                  <LoadingButton
                    disabled={csvDocumentData?.loading || getDocumentRes?.loading}
                    startIcon={<FileDownloadOutlined />}
                    variant="contained"
                    size="small"
                    sx={{
                      whiteSpace: 'nowrap',
                      height: 35,
                      width: 120,
                      ':hover': {
                        background: '#6366F1',
                      },
                      '.MuiLoadingButton-loadingIndicator': {
                        left: 15,
                      },
                    }}
                    loadingPosition="start"
                    onClick={handleDownloadCSV}
                    loading={csvDocumentData?.loading || getDocumentRes?.loading}
                  >
                    Download
                  </LoadingButton>
                </Box>
              </Box>
            </>
          }
        />

        <Scrollbar>
          <>
            <Stack gap="1rem">
              <TableContainer
                component={Paper}
                sx={{ height: 700 }}
              >
                <InfiniteScroll
                  dataLength={getDocumentRes?.totalFacility?.length}
                  next={() => {
                    getAllDocumentApiCall(getDocumentRes?.pageNumber);
                  }}
                  style={{
                    overflow: 'scroll',
                    height: 700,
                  }}
                  height={800}
                  hasMore={
                    getDocumentRes?.response?.data?.totalElements !==
                    getDocumentRes?.totalFacility?.length
                  }
                  loader={
                    getDocumentRes?.loading ? (
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          height: 250,
                          width: '100%',
                          // marginTop: ,
                        }}
                      >
                        <img
                          src={LoaderIcon}
                          alt="loader.."
                        />
                      </div>
                    ) : !getDocumentRes?.isGetDocuments && getDocumentRes?.response !== null ? (
                      <Box>
                        <img
                          src={emptyImg}
                          alt="loader"
                          style={{
                            width: 720,
                            height: 300,
                            margin: 'auto',
                            alignItems: 'center',
                            alignContent: 'center',
                            marginTop: 100,
                            display: 'block',
                          }}
                        />

                        <Typography
                          color={'text.secondary'}
                          variant="h5"
                          fontWeight={'200'}
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                          }}
                        >
                          Something went's wrong
                        </Typography>
                      </Box>
                    ) : null
                  }
                  endMessage={
                    <Box
                      textAlign="center"
                      p={3}
                    >
                      {getDocumentRes?.totalFacility?.length === 0 ? (
                        <Box>
                          <img
                            src={emptyImg}
                            alt="loader"
                            style={{
                              width: 720,
                              height: 300,
                              margin: 'auto',
                              alignItems: 'center',
                              alignContent: 'center',
                              marginTop: 100,
                              display: 'block',
                            }}
                          />

                          <Typography
                            color={'text.secondary'}
                            variant="h5"
                            fontWeight={'200'}
                          >
                            No results found
                          </Typography>
                        </Box>
                      ) : null}
                    </Box>
                  }
                >
                  <Table
                    stickyHeader
                    sx={{ minWidth: 700 }}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell>
                          <TableSortLabel
                            active={sortConfig.key === 'patientName'}
                            direction={
                              sortConfig.key === 'patientName' ? sortConfig.direction : 'asc'
                            }
                            onClick={() => handleSort('patientName')}
                          >
                            Patient
                          </TableSortLabel>
                          <MultiSelectWithSearch
                            options={getAllPatientList}
                            pageNo={pageNo}
                            setPageNo={setPageNo}
                            handleSortMultiselect={handleSortMultiselect}
                            setAppliedValues={setSelectedPatient}
                            appliedValues={selectedPatient}
                            sortConfig={sortConfig}
                          />
                        </TableCell>
                        <TableCell>
                          <TableSortLabel
                            active={sortConfig.key === 'discipline'}
                            direction={
                              sortConfig.key === 'discipline' ? sortConfig.direction : 'asc'
                            }
                            onClick={() => handleSort('discipline')}
                          >
                            Discipline
                          </TableSortLabel>
                          <TableHeaderMultiselect
                            label="Discipline"
                            sortConfig={sortConfig}
                            appliedValues={selectedDisciples}
                            setAppliedValues={setSelectedDisciples}
                            options={DisciplineType}
                            handleSortMultiselect={handleSortMultiselect}
                          />
                        </TableCell>

                        <TableCell>
                          <TableSortLabel
                            active={sortConfig.key === 'documentType'}
                            direction={
                              sortConfig.key === 'documentType' ? sortConfig.direction : 'asc'
                            }
                            onClick={() => handleSort('documentType')}
                          >
                            Document Type
                          </TableSortLabel>
                          <TableHeaderMultiselect
                            label="Document Type"
                            sortConfig={sortConfig}
                            appliedValues={selectedDocumentType}
                            setAppliedValues={setSelectedDocumentType}
                            options={documentTypes}
                            handleSortMultiselect={handleSortMultiselect}
                          />
                        </TableCell>

                        <TableCell>
                          <TableSortLabel
                            active={sortConfig.key === 'therapistName'}
                            direction={
                              sortConfig.key === 'therapistName' ? sortConfig.direction : 'asc'
                            }
                            onClick={() => handleSort('therapistName')}
                          >
                            Therapist
                          </TableSortLabel>
                          <TableHeaderMultiselect
                            label="Therapist"
                            appliedValues={selectedTherapist}
                            sortConfig={sortConfig}
                            setAppliedValues={setSelectedTherapist}
                            options={getTherapistList}
                            handleSortMultiselect={handleSortMultiselect}
                          />
                        </TableCell>

                        <TableCell>
                          <TableSortLabel
                            active={sortConfig.key === 'dueDate'}
                            direction={sortConfig.key === 'dueDate' ? sortConfig.direction : 'asc'}
                            onClick={() => handleSort('dueDate')}
                          >
                            Due date
                          </TableSortLabel>
                          <MenuDateFilter
                            label="Due Date"
                            setSelectedDueDate={setSelectedDueDate}
                            selectedDueDate={selectedDueDate}
                          />
                        </TableCell>

                        <TableCell>
                          <TableSortLabel
                            active={sortConfig.key === 'dueStatus'}
                            direction={
                              sortConfig.key === 'dueStatus' ? sortConfig.direction : 'asc'
                            }
                            onClick={() => handleSort('dueStatus')}
                          >
                            Status
                          </TableSortLabel>
                          <TableHeaderMultiselect
                            label="Status"
                            appliedValues={selectedStatus}
                            sortConfig={sortConfig}
                            setAppliedValues={setSelectedStatus}
                            options={docStatusTypes}
                            handleSortMultiselect={handleSortMultiselect}
                          />
                        </TableCell>

                        <TableCell>Action</TableCell>
                        <TableCell align="right"></TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody sx={{ height: 1 }}>
                      {getDocumentRes?.totalFacility?.map((document: any) => {
                        return (
                          document.status !== 'COMPLETED' && (
                            <TableRow
                              hover
                              key={document?.uuid}
                            >
                              <TableCell>
                                <Box>
                                  <Typography variant="subtitle2">
                                    {document?.patientName}
                                  </Typography>
                                </Box>
                              </TableCell>
                              <TableCell>
                                <Typography variant="subtitle2">{document?.type}</Typography>
                              </TableCell>

                              <TableCell>
                                <Stack
                                  alignItems="center"
                                  direction="row"
                                  spacing={1}
                                >
                                  <Grid
                                    container
                                    sx={{ alignItems: 'center' }}
                                  >
                                    <Box sx={{ marginRight: '4px', marginTop: '7px' }}>
                                      <DocumentIcons
                                        iconType={document?.formType
                                          ?.split('_')?.[0]
                                          ?.toLowerCase()}
                                      />
                                    </Box>

                                    <Box sx={{ display: 'flex' }}>
                                      <Typography variant="subtitle2">
                                        {document?.documentType}
                                      </Typography>
                                    </Box>
                                  </Grid>
                                </Stack>
                              </TableCell>

                              <TableCell>
                                <Typography variant="subtitle2">
                                  {' '}
                                  {document?.supervisorName}
                                </Typography>
                              </TableCell>
                              <TableCell>
                                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                  <Typography variant="subtitle2">
                                    {document?.dueDate
                                      ? format(
                                          new Date(
                                            new Date(document?.dueDate)?.valueOf() +
                                              new Date(document?.dueDate)?.getTimezoneOffset() *
                                                60 *
                                                1000
                                          ),
                                          'dd MMM, yyyy'
                                        )
                                      : '-'}
                                  </Typography>
                                  <Typography
                                    sx={{ color: '#6C737F' }}
                                    variant="caption"
                                  >
                                    {getDisplayString(document?.dueDate)}
                                  </Typography>
                                </Box>
                              </TableCell>
                              <TableCell>
                                <Box sx={{ display: 'flex', ml: '-20px' }}>
                                  {'OVERDUE' === document?.status ? (
                                    <Chip
                                      label={
                                        <Typography variant="overline">
                                          {document.status}
                                        </Typography>
                                      }
                                      variant="outlined"
                                      sx={{
                                        marginLeft: '10px',
                                        color: '#B42318',
                                        backgroundColor: '#F044381F',
                                      }}
                                    />
                                  ) : 'DUE TODAY' === document?.status ? (
                                    <Chip
                                      label={
                                        <Typography variant="overline">
                                          {document.status}
                                        </Typography>
                                      }
                                      variant="outlined"
                                      sx={{
                                        marginLeft: '10px',
                                        color: '#B54708',
                                        backgroundColor: '#F790091F',
                                      }}
                                    />
                                  ) : 'COMPLETED' === document?.status ? (
                                    <Chip
                                      label={
                                        <Typography variant="overline">
                                          {document.status}
                                        </Typography>
                                      }
                                      variant="outlined"
                                      sx={{
                                        marginLeft: '10px',
                                        color: '#107569',
                                        backgroundColor: 'rgba(21, 183, 158, 0.12)',
                                      }}
                                    />
                                  ) : 'UPCOMING DEADLINE' === document?.status ? (
                                    <Chip
                                      label={
                                        <Typography variant="overline">
                                          {document.status}
                                        </Typography>
                                      }
                                      variant="outlined"
                                      sx={{
                                        marginLeft: '10px',
                                        color: '#6C737F',
                                        backgroundColor: 'rgba(17, 25, 39, 0.08)',
                                      }}
                                    />
                                  ) : (
                                    '-'
                                  )}
                                </Box>
                              </TableCell>
                              <TableCell>
                                <Typography
                                  sx={{ color: '#6C737F', display: 'block', width: '20px' }}
                                  variant="caption"
                                >
                                  {!document?.submissionId
                                    ? 'Complete document'
                                    : document?.forSign
                                    ? 'Sign document'
                                    : document?.supervisorStatus === 'PENDING' &&
                                      document?.supervisorId === null
                                    ? document?.formType?.includes('EVALUATION') ||
                                      document?.formType?.includes('RECERTIFICATION')
                                      ? 'Select physician'
                                      : 'Select supervisor'
                                    : document?.supervisorId !== null &&
                                      document?.supervisorStatus === 'PENDING' &&
                                      (document?.formType?.includes('EVALUATION') ||
                                        document?.formType?.includes('RECERTIFICATION'))
                                    ? 'Physician signature pending'
                                    : document?.supervisorId !== null &&
                                      document?.supervisorStatus === 'PENDING' &&
                                      (!document?.formType?.includes('EVALUATION') ||
                                        !document?.formType?.includes('RECERTIFICATION'))
                                    ? 'Supervisor signature pending'
                                    : '-'}
                                </Typography>
                              </TableCell>

                              <TableCell align="left">
                                {document?.providerId === providerId ? (
                                  <>
                                    {document?.forSign && (
                                      <IconButton
                                        title="Sign Document"
                                        onClick={() => handleSignatureNavigation(document)}
                                      >
                                        <SvgIcon>
                                          <BorderColorOutlinedIcon />
                                        </SvgIcon>
                                      </IconButton>
                                    )}

                                    {document?.submissionId && (
                                      <IconButton
                                        title="View Document"
                                        onClick={() => previewDocument(document)}
                                      >
                                        <ClipBoard />
                                      </IconButton>
                                    )}

                                    {document?.status !== 'COMPLETED' &&
                                      document?.submissionId &&
                                      checkEditPermission(document) && (
                                        <IconButton
                                          title="Edit Document"
                                          onClick={() => handleDocumentEdit(document)}
                                        >
                                          <Edit02Icon />
                                        </IconButton>
                                      )}

                                    {document?.supervisorStatus === 'PENDING' &&
                                      document?.supervisorId === null && (
                                        <IconButton
                                          onMouseEnter={(event: any) =>
                                            handleClick(event, document)
                                          }
                                          aria-controls={open ? 'basic-menu' : undefined}
                                          aria-haspopup="true"
                                          aria-expanded={open ? 'true' : undefined}
                                          sx={{ cursor: 'pointer' }}
                                        >
                                          <ArrowForwardIcon sx={{ color: '#6C737F' }} />
                                        </IconButton>
                                      )}

                                    {!document?.submissionId && (
                                      <IconButton
                                        title="Complete Document"
                                        onClick={() => handleDocumentEdit(document)}
                                      >
                                        <PlusIcon />
                                      </IconButton>
                                    )}
                                  </>
                                ) : document?.supervisorId === providerId ? (
                                  <>
                                    {document?.forSign && (
                                      <IconButton
                                        title="Sign Document"
                                        onClick={() => handleSignatureNavigation(document)}
                                      >
                                        <SvgIcon>
                                          <BorderColorOutlinedIcon />
                                        </SvgIcon>
                                      </IconButton>
                                    )}

                                    {document?.submissionId && (
                                      <IconButton
                                        title="View Document"
                                        onClick={() => previewDocument(document)}
                                      >
                                        <ClipBoard />
                                      </IconButton>
                                    )}
                                    {document?.supervisorStatus === 'PENDING' &&
                                      document?.supervisorId !== null && (
                                        <IconButton
                                          onMouseEnter={(event: any) =>
                                            handleClick(event, document)
                                          }
                                          aria-controls={open ? 'basic-menu' : undefined}
                                          aria-haspopup="true"
                                          aria-expanded={open ? 'true' : undefined}
                                          sx={{ cursor: 'pointer' }}
                                        >
                                          <ArrowForwardIcon sx={{ color: '#6C737F' }} />
                                        </IconButton>
                                      )}
                                  </>
                                ) : (
                                  <>
                                    {document?.submissionId && (
                                      <IconButton
                                        title="View Document"
                                        onClick={() => previewDocument(document)}
                                      >
                                        <ClipBoard />
                                      </IconButton>
                                    )}
                                  </>
                                )}
                              </TableCell>
                            </TableRow>
                          )
                        );
                      })}
                    </TableBody>
                  </Table>
                </InfiniteScroll>
              </TableContainer>
            </Stack>
          </>
        </Scrollbar>
      </Card>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onMouseLeave={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <Box onMouseLeave={handleClose}>
          <Typography>
            <Button
              onClick={() => goToEoc(getCurrentItem)}
              endIcon={<RightIcon />}
            >
              Go to Episode of Care
            </Button>
          </Typography>
        </Box>
      </Menu>

      {/* clock in modal */}
      {canShowClockInDialog() && (
        <BootstrapDialog
          PaperProps={{ style: { maxWidth: '750px' } }}
          onClose={() => setIsClockIn(false)}
          aria-labelledby="customized-dialog-title"
          open={isClockIn && !notToShowAgain}
        >
          <ClockInOutModal
            close={handleIsClock}
            handleClockIn={HandleStartClock}
          />
        </BootstrapDialog>
      )}

      <Modal
        open={showForm.opemForm || showForm.formId !== ''}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          height: '100%',
        }}
        onClose={handleModalClose}
      >
        <iframe
          src={`${viewFormByFormID(showForm.formId)}`}
          width={'60%'}
          ref={updateIFrameRef}
          height={'80%'}
          title="Accessible Name"
        />
      </Modal>

      {/* Discharge Alert */}
      <BootstrapDialog
        PaperProps={{ style: { maxWidth: '100%' } }}
        onClose={() => setShowDischargeModal(false)}
        aria-labelledby="customized-dialog-title"
        open={showDischargeModal}
      >
        <DischargeRecheckModal
          handleDelete={() => setShowDischargeModal(false)}
          title="and Discharge"
          message={`The following items have not been completed.`}
          buttontext="Got it"
          requiredDocument={actionToBeContinue === 'EDIT_DOCUMENT' ? true : false}
          document={selectedDocument}
          source='DASHBOARD'
        />
      </BootstrapDialog>
    </>
  );
};

export default DocumentManagement;
